import AdminWorks from "../../../../components/Admin/admin-sections/AdminWorks"

const AdminWorksPage = () => {
    return <AdminWorks />    
}

export default AdminWorksPage